module.exports = __webpack_public_path__ + "img/lock.e2d59faa.svg";